/**
 * Запросы на отправку в NetBox: счётчики для значка в меню и номер
 * версии. Версия растёт при каждом событии об изменении запросов или
 * отметок «Готово к отправке» — открытые экраны по ней перечитывают
 * данные, не дожидаясь перезагрузки страницы.
 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../api/client';
import { canSeeRequests } from '../../domain/netboxRequests';

// Счётчики нужны только тем, кому виден раздел «Запросы в NetBox»:
// остальным сервер список запросов не отдаёт.
export const loadNetboxCounts = createAsyncThunk(
  'netbox/loadCounts',
  async () => {
    const data = await api.get('/api/netbox/requests?status=open&limit=1');
    return data.counts;
  },
  {
    condition: (_, { getState }) => canSeeRequests(getState().auth.user),
  }
);

const netboxSlice = createSlice({
  name: 'netbox',
  initialState: { counts: { pending: 0, ready: 0 }, version: 0 },
  reducers: {
    netboxChanged(state) {
      state.version += 1;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadNetboxCounts.fulfilled, (state, action) => {
      if (action.payload) state.counts = action.payload;
    });
  },
});

export const { netboxChanged } = netboxSlice.actions;
export const selectNetboxCounts = (state) => state.netbox.counts;
export const selectNetboxVersion = (state) => state.netbox.version;

/** Событие пришло или собственное действие выполнено: перечитать всё. */
export const refreshNetbox = () => (dispatch) => {
  dispatch(netboxChanged());
  dispatch(loadNetboxCounts());
};

export default netboxSlice.reducer;
